import { Graph } from '../../Class/Graph'
import { G_EE } from '../../types/interface/G'
import { GraphMoment } from '../GraphMoment'

export interface GraphDestroyMomentData {}

export interface GraphDestroyMoment
  extends GraphMoment<GraphDestroyMomentData> {}

export function extractDestroyEventData([
  path,
]: G_EE['destroy']): GraphDestroyMoment['data'] {
  return {
    path,
  }
}

export function stringifyBulkEditEventData({
  path,
}: GraphDestroyMoment['data']) {
  return {
    path,
  }
}

export function watchGraphDestroyEvent(
  event: 'destroy',
  graph: Graph,
  callback: (moment: GraphDestroyMoment) => void
): () => void {
  const listener = (path: string[] = []) => {
    callback({
      type: 'unit',
      event,
      data: {
        path,
      },
    })
  }

  graph.prependListener(event, listener)

  return () => {
    graph.removeListener(event, listener)
  }
}
